export default __webpack_public_path__ + "static/media/NRBC.3d21e795.png";